// src/hooks/use-resize-observer.ts
import { useEffect, useRef } from "react";
import { debounce } from "es-toolkit";
function useResizeObserver(callback) {
  let debounceTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  let deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return void 0;
    const observer = new ResizeObserver(debounce(() => {
      callback(ref.current);
    }, debounceTime));
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [callback, deps, debounceTime]);
  return ref;
}
var use_resize_observer_default = useResizeObserver;
export { use_resize_observer_default };